import { Card, CardMedia } from '@mui/material'
import { useState } from 'react'

const DevelopersBanner = () => {
  const [raised, setRaised] = useState(false)

  const toggleRaised = () => {
    setRaised(!raised)
  }
  return (
    <Card
      square={false}
      onMouseOver={toggleRaised}
      onMouseOut={toggleRaised}
      raised={raised}
      sx={{
        p: 6,
        backgroundColor: `#05B871`,
        border: 2,
        borderColor: 'black'
      }}
    >
      <CardMedia
        component="img"
        width="80%"
        image="/terminal-white-bg-2.svg"
        alt="Developer's Terminal program"
        sx={{
          border: 2,
          borderRadius: 1,
          borderColor: 'black'
        }}
      />
    </Card>
  )
}

export default DevelopersBanner
